import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux'
import { Table, Tag, Dropdown, message } from 'antd'
import {
    EditOutlined,
} from '@ant-design/icons';

// Constants
import { 
    TEMPLATE,
    ROUTES, 
    COMMON_FEATURES 
} from '../../../../constants'

// Components
import { EmptyIndicator } from '../../../../components/Indicator'
// import { VehiclePackageLabel, VehiclePackageStatus } from '../../../../components/VehiclePackage'
// import { VehiclePackageLabel } from '../../../../components/VehiclePackage'
import { PrimaryButton } from '../../../../components/Decoration/Button';
import ModalStandard from '../../../../components/ModalStandard';
// import DrawerWrapper from '../../../../components/DrawerWrapper';
import VehiclePlateECUTag from '../../../../components/VehiclePlateECUTag'
import Loading from '../../../../components/Loading'
// import SVG from '../../../../components/SVG';

// Services
import { TIME, REDUX } from '../../../../services/util'

// Handler
import {
    table_handler,
    // vehicles_handler
} from '../../../../handlers'

// Redux Actions
import * as REDUX_ACTIONS from '../../../../services/redux/actions'

const { getColumnSearchProps } = table_handler
// const { vehicleECUValidator } = vehicles_handler
const { parseDate } = TIME

const {
    STATUS_LABEL
} = TEMPLATE.VEHICLE


const DevicePanel = () => {

    const navigate = useNavigate()
    const dispatch = useDispatch()
    
    const { pathname } = useLocation()

    const { uid } = useSelector(REDUX.reduxStoreWrapper('user'))
    const users = useSelector(REDUX.reduxStoreWrapper('userHierarchy.byID'))
    const deviceStaticses = useSelector(REDUX.reduxStoreWrapper('devices.staticsByID')) 
    const deviceMDVRs = useSelector(REDUX.reduxStoreWrapper('devicesMDVR.byID')) 
    const vehicleStaticses = useSelector(REDUX.reduxStoreWrapper('vehicles.staticsByID')) 
    const loading = useSelector(REDUX.reduxStoreWrapper('style.loading.vehicle'))

    const [ dataSource, setDataSource ] = useState([])
    const [ isLoaded, setIsLoaded ] = useState(false);
    
    const searchTextState = useState('')
    const searchedColumnState = useState('')

    const usePrevious = (value) => {
        const ref = useRef();
        useEffect(() => {
          ref.current = value;
        });
        return ref.current;
    }

    const prevVehicles = usePrevious(deviceStaticses);
    const prevPathname = usePrevious(pathname)

    const refreshDataSrc = () => {

        let newDataSource = []

        switch(pathname) {
            case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]: {
                newDataSource = Object.values(deviceStaticses)
                    .sort((b, a) => b.plate - a.plate)
                    .map(deviceStatics => {
                        const dvid = deviceStatics.dvid
        
                        const vehicle = Object.values(vehicleStaticses).find(v => v.dvid === dvid)
                        const company = users[deviceStatics?.company]?.name || '-'
                        const contact = users[deviceStatics?.company]?.contact || '-'
                        
                        return {
                            ...deviceStatics,
                            key: dvid,
                            imei: dvid?.split('#')[1],
                            plate: vehicle?.plate || '-',
                            status: deviceStatics.status || 0,
                            company,
                            contact
                        }
                    })

                    break;
            }

            case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT]: {
                newDataSource = Object.values(deviceMDVRs)
                    .map(device => {
                        const mdvrid = device.mdvrid
        
                        const vehicle = Object.values(vehicleStaticses).find(v => v.mdvrid === mdvrid)
                        const company = users[device?.company]?.name || '-'
                        const contact = users[device?.company]?.contact || '-'
                        
                        return {
                            ...device,
                            key: mdvrid,
                            // imei: dvid?.split('#')[1],
                            imei: mdvrid,
                            plate: vehicle?.plate || '-',
                            status: device.status || 0,
                            company,
                            contact
                        }
                    })
    
                    break;
            }

        }

        setDataSource(newDataSource)
    }

    const devicePanelColumns = [
        {
          title: "Device IMEI",
          dataIndex: "imei",
          fixed: 'left',
          ...getColumnSearchProps("Device IMEI", 'imei', searchTextState, searchedColumnState),
        },
        {
          title: "Vehicle Plate",
          dataIndex: "plate",
          ...getColumnSearchProps("Vehicle Plate", 'plate', searchTextState, searchedColumnState, (plate, vehicle) => <VehiclePlateECUTag plate={plate} vehicle={vehicle}/>),
        },
        {
            title: "Device SIM",
            dataIndex: "simContact",
            ...getColumnSearchProps("Device SIM", 'simContact', searchTextState, searchedColumnState),
          },
        {
            title: "Phone Number",
            dataIndex: "contact",
            ...getColumnSearchProps("Phone Number", 'contact', searchTextState, searchedColumnState),
          },
          {
            title: "Company",
            dataIndex: "company",
            ...getColumnSearchProps("Company", 'company', searchTextState, searchedColumnState, (plate, vehicle) => <VehiclePlateECUTag plate={plate} vehicle={vehicle}/>),
          },
          {
            title: "Model",
            dataIndex: "model",
            ...getColumnSearchProps("Model", "model", searchTextState, searchedColumnState),
          },
        {
          title: "Status",
          dataIndex: "status",
            filters: Object.values(STATUS_LABEL).map(sl => ({
                text: <Tag color={STATUS_LABEL[sl.status]?.color}>{STATUS_LABEL[sl.status]?.label}</Tag>,
                value: sl.status
            })),
            onFilter: (value, record) => record.status === Number(value),
            render: (data) => 
                <Tag color={STATUS_LABEL[data]?.color}>
                    {STATUS_LABEL[data]?.label}
                </Tag>,
        },
          {
            title: "Last Updated By",
            defaultSortOrder: "descend",
            width: 250,
            sorter: (a, b) => a.updatedAt - b.updatedAt,
            render: (data) => {
                const name = users[data.updatedBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.updatedAt))}</>
                    </>
                )
            }
          },
        {
            title: "Created By",
            width: 250,
            sorter: (a, b) => a.createdAt - b.createdAt,
            render: (data) => {
                const name = users[data.createdBy]?.name

                return (
                    <>
                        <>{name}</><br/>
                        <>{parseDate(Number(data.createdAt))}</>
                    </>
                )
            }
          },
        {
            title: "Actions",
            fixed: 'right',
            render: data => {

                const dataItems = {
                    dvid: data.dvid,
                    simContact: data.simContact,
                    company: data.company,
                    uid,
                    mdvrid: data.mdvrid
                }

                const items = [
                    {
                        key: '1',
                        label: 
                            <span 
                                className="ButtonLink"
                                aria-hidden="true"
                                onClick = {() => navigate(`/update/device`, { state: { data: { ...data, title: 'Edit', prevPathname: pathname } }})}
                            >
                                Edit
                            </span>
                    },
                    {
                        key: '2',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                switch(pathname) {
                                    case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]: {
                                        dispatch(REDUX_ACTIONS.v3_devices.update_device_request({
                                                ...dataItems,
                                                status: 1,
                                            },
                                            () => {},
                                            () => message.error('Failed in Mark the device as Inactive. Retry?')
                                        ))
                                        break;
                                    }
                                    case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT]: {
                                        dispatch(REDUX_ACTIONS.v3_devicesMDVR.update_device_mdvr_request({
                                                ...dataItems,
                                                status: 1,
                                            },
                                            () => {},
                                            () => message.error('Failed in Mark the device as Inactive. Retry?')
                                        ))
                                        break;
                                    }
                                }
                            }}
                            disabled={data.status === 1}
                            title={'Mark as active'}
                            content={'You are about to mark this device as active.'}
                            subcontent={`${data.imei || '-'}`}
                            // icon={<></>}
                        >
                            Mark as active
                        </ModalStandard>
                    },
                    {
                        key: '3',
                        label: 
                        <ModalStandard 
                            onClick={() => {
                                switch(pathname) {
                                    case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.GPS_MANAGEMENT]: {
                                        dispatch(REDUX_ACTIONS.v3_devices.update_device_request({
                                                ...dataItems,
                                                status: 0,
                                            },
                                            () => {},
                                            () => message.error('Failed in Mark the device as Inactive. Retry?')
                                        ))
                                        break;
                                    }
                                    case ROUTES.MODULE_ROUTE[COMMON_FEATURES.FEATURE_NAME.MDVR_MANAGEMENT]: {
                                        dispatch(REDUX_ACTIONS.v3_devicesMDVR.update_device_mdvr_request({
                                                ...dataItems,
                                                status: 0,
                                            },
                                            () => {},
                                            () => message.error('Failed in Mark the device as Inactive. Retry?')
                                        ))
                                        break;
                                    }
                                }
                            }}
                            disabled={data.status === 0}
                            title={'Mark as inactive'}
                            content={'You are about to mark this device as inactive.'}
                            subcontent={`${data.imei || '-'}`}
                            // icon={<></>}
                        >
                            Mark as inactive
                        </ModalStandard>
                    }
                ]

                return (
                    <Dropdown menu={{ items }}>
                        <EditOutlined />
                    </Dropdown>
                )

            }
          }
      ];

      useEffect(() => {
        // setIsLoaded(Object.values(deviceStaticses).length > 0 || (Object.values(deviceStaticses).length === 0 && !loading));
        setIsLoaded(true);
        if ((prevVehicles !== deviceStaticses) || (prevPathname !== pathname)) {
            refreshDataSrc();
        }
    }, [deviceStaticses, pathname]);

    return (
        <div >
            <PrimaryButton htmlType={'submit'} style={{ float: 'right', marginBottom: '15px' }} onClick={() => navigate (`/create/device`,  { state: { data: { prevPathname: pathname } }})}>+ Create device</PrimaryButton>
            {   !isLoaded ? 
                <Loading /> :
                dataSource.length > 0 ?
                    <Table
                        loading={loading}
                        columns={devicePanelColumns && devicePanelColumns.filter(c => !c.isHidden)}
                        dataSource={dataSource}
                        pagination={true}
                        scroll={{
                            y: window.innerHeight,
                            x: devicePanelColumns && devicePanelColumns.length * 200
                        }}
                    /> 
                :
                    <EmptyIndicator />
            }
        </div>
    )
}

export default DevicePanel